/**
 * A user favorite : a named group of KPI ids that can be applied to the KPI selection
 */
export interface KpiFavorite {
  id: string;
  label: string;
  kpis: string[];
}

export function isKpiFavorite(obj: unknown): obj is KpiFavorite {
  return (
    typeof obj === 'object' &&
    obj !== null &&
    'id' in obj &&
    'label' in obj &&
    'kpis' in obj &&
    Array.isArray((obj as KpiFavorite).kpis)
  );
}
